var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "p-0 m-0",
    attrs: {
      "header": "Biometrics"
    }
  }, [_c('b-form', [_c('b-form-group', {
    staticClass: "mb-2"
  }, [_c('label', {
    attrs: {
      "for": _vm.gender.name
    }
  }, [_vm._v(_vm._s(_vm.gender.placeholder))]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "id": _vm.gender.name,
      "name": _vm.gender.name,
      "size": "sm"
    },
    model: {
      value: (_vm.model.gender),
      callback: function($$v) {
        _vm.$set(_vm.model, "gender", $$v)
      },
      expression: "model.gender"
    }
  }, [_c('option', {
    key: "0",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an option")]), _vm._v(" "), _vm._l((_vm.gender.options), function(option, i) {
    return _c('option', {
      key: i + 1,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n            " + _vm._s(option) + "\n          ")])
  })], 2)], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "mb-2"
  }, [_c('label', {
    attrs: {
      "for": _vm.canPlaySports.name
    }
  }, [_vm._v(_vm._s(_vm.canPlaySports.placeholder))]), _vm._v(" "), _c('b-form-radio-group', {
    attrs: {
      "id": _vm.canPlaySports.name,
      "name": _vm.canPlaySports.name,
      "options": _vm.canPlaySports.options
    },
    model: {
      value: (_vm.model.canPlaySports),
      callback: function($$v) {
        _vm.$set(_vm.model, "canPlaySports", $$v)
      },
      expression: "model.canPlaySports"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "mb-2"
  }, [_c('label', {
    attrs: {
      "for": _vm.height.name
    }
  }, [_vm._v(_vm._s(_vm.height.placeholder))]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "id": _vm.height.name,
      "name": _vm.height.name,
      "size": "sm"
    },
    model: {
      value: (_vm.model.height),
      callback: function($$v) {
        _vm.$set(_vm.model, "height", $$v)
      },
      expression: "model.height"
    }
  }, [_c('option', {
    key: "0",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an option")]), _vm._v(" "), _vm._l((_vm.height.options), function(option, i) {
    return _c('option', {
      key: i + 1,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n            " + _vm._s(option) + "\n          ")])
  })], 2)], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "mb-2"
  }, [_c('label', {
    attrs: {
      "for": _vm.weight.name
    }
  }, [_vm._v(_vm._s(_vm.weight.placeholder))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": _vm.weight.name,
      "name": _vm.weight.name,
      "placeholder": "Enter weight (lbs)"
    },
    model: {
      value: (_vm.model.weight),
      callback: function($$v) {
        _vm.$set(_vm.model, "weight", $$v)
      },
      expression: "model.weight"
    }
  })], 1), _vm._v(" "), _c('div', [(!_vm.signup) ? _c('div', {
    staticClass: "w-100 d-flex justify-content-between pt-2"
  }, [_c('b-button', {
    staticClass: "bg-danger",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleBiometrics')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: (_vm.modals.save._id),
      expression: "modals.save._id"
    }],
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm",
      "disabled": _vm.isDisabled
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Submit")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1) : _c('div', {
    staticClass: "w-100 d-flex justify-content-between pt-2"
  }, [_c('div'), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Submit")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "_id": _vm.modals.save._id,
      "message": _vm.modals.save.message
    },
    on: {
      "success": _vm.handleSubmit
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c052b92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Biometrics/BiometricsForm.vue
// module id = tH8F
// module chunks = 2